(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9961],{

/***/ 80839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Box__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(80343);
/* harmony import */ var _material_ui_core_Container__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(43832);
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(22318);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86010);
/* harmony import */ var components_atoms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69251);
/* harmony import */ var constants_Images__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13270);
/* harmony import */ var constants_Paths__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(199);
/* harmony import */ var constants_data_contact__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7241);
/* harmony import */ var constants_data_mobile__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76412);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5233);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67294);
/* harmony import */ var utils_ImageFallback__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34588);
/* harmony import */ var zustand_lib_storeGlobal__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(39423);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(45045);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_13__);


















var FooterCam = function(param) {
    var _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile;
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)("common"), translateCommon = ref.t;
    var policies = (0,zustand_lib_storeGlobal__WEBPACK_IMPORTED_MODULE_11__/* .useStore */ .o)(function(state) {
        return state.policies;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_9__.useEffect)(function() {
        var _loop = function(i) {
            var hoverArea = hoverAreas[i];
            var hoverAreaId = hoverArea.id;
            var imageId = (hoverAreaId === null || hoverAreaId === void 0 ? void 0 : hoverAreaId.split("_")[0]) || "";
            if (imageId !== "") {
                var image = document.getElementById(imageId);
                hoverArea === null || hoverArea === void 0 ? void 0 : hoverArea.addEventListener("mouseenter", function() {
                    image.src = "/static/images/footer/".concat(imageId, "_active.svg");
                });
                hoverArea === null || hoverArea === void 0 ? void 0 : hoverArea.addEventListener("mouseleave", function() {
                    image.src = "/static/images/footer/".concat(imageId, "_inactive.svg");
                });
            }
        };
        var hoverAreas = document.getElementsByClassName("general_info");
        // eslint-disable-next-line no-plusplus
        for(var i = 0; i < hoverAreas.length; i++)_loop(i);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: "app-footer",
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(!isMobile ? (_styles_module_css__WEBPACK_IMPORTED_MODULE_13___default().footer) : (_styles_module_css__WEBPACK_IMPORTED_MODULE_13___default().mobile_footer)),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Container__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
            style: {
                maxWidth: "1328px",
                fontFamily: "ggsm"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                container: true,
                justifyContent: "space-between",
                direction: !isMobile ? "row" : "column",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                        item: true,
                        xs: !isMobile ? 6 : 12,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms__WEBPACK_IMPORTED_MODULE_1__/* .LinkComp */ .vk, {
                                href: "/",
                                padding: "0px",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                                    src: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .BRAND_LOGO_SVG */ .jDq,
                                    width: "118",
                                    height: "25"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                style: {
                                    marginTop: "8px"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                    style: {
                                        fontWeight: "bold",
                                        fontFamily: "ggsm"
                                    },
                                    children: "Buymed Cambodia Co., Ltd"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                style: {
                                    marginTop: !isMobile ? "16px" : "12px",
                                    display: "flex"
                                },
                                children: [
                                    !isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        style: {
                                            marginRight: "8px",
                                            width: "40px"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                                            src: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .LOGO_FOOTER_LOCATION */ .KLt,
                                            width: "40",
                                            height: "40"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        style: {
                                            flex: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                style: {
                                                    fontSize: "12px",
                                                    fontFamily: "ggsm"
                                                },
                                                children: translateCommon("footer.company_address")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_13___default().info_content),
                                                children: translateCommon("footer.full_company_address")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                style: {
                                    marginTop: !isMobile ? "16px" : "12px",
                                    display: "flex"
                                },
                                children: [
                                    !isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        style: {
                                            marginRight: "8px"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                                            src: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .LOGO_FOOTER_CONTACT */ .PwW,
                                            width: "40",
                                            height: "40"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                style: {
                                                    fontSize: "12px",
                                                    fontFamily: "ggsm"
                                                },
                                                children: translateCommon("footer.hotline")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                style: {
                                                    display: "flex",
                                                    color: "#1B4BE5",
                                                    fontSize: "14px",
                                                    paddingTop: "4px"
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    href: "tel:098888437",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_13___default().info_content),
                                                    children: constants_data_contact__WEBPACK_IMPORTED_MODULE_4__/* .PHONE_NUMBER_CONTACT */ .N9
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                style: {
                                    marginTop: "16px",
                                    display: "flex"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                                        src: "/static/images/footer/copyright.svg",
                                        width: "16",
                                        height: "16"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        style: {
                                            fontFamily: "ggsr",
                                            fontSize: "12px",
                                            color: "#606060",
                                            marginLeft: "5px"
                                        },
                                        children: translateCommon("footer.copy_right")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                        item: true,
                        container: true,
                        direction: !isMobile ? "row" : "column",
                        xs: !isMobile ? 6 : 12,
                        justifyContent: "flex-end",
                        children: [
                            (policies === null || policies === void 0 ? void 0 : policies.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                item: true,
                                xs: 4,
                                container: true,
                                direction: "column",
                                style: {
                                    margin: !isMobile ? "0px" : "24px 0px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_13___default().general_info_title),
                                        children: translateCommon("footer.policies")
                                    }),
                                    policies.map(function(policy, index) {
                                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                            item: true,
                                            container: true,
                                            alignItems: "center",
                                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_13___default().policyItem),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms__WEBPACK_IMPORTED_MODULE_1__/* .LinkComp */ .vk, {
                                                href: "/policy?code=".concat((policy === null || policy === void 0 ? void 0 : policy.code) || ""),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_13___default().policyName),
                                                    children: (policy === null || policy === void 0 ? void 0 : policy.name) || ""
                                                })
                                            })
                                        }, (policy === null || policy === void 0 ? void 0 : policy.code) || index);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                item: true,
                                container: true,
                                xs: !isMobile ? 3 : 5,
                                style: {
                                    margin: !isMobile ? "0px" : "16px 0px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                        item: true,
                                        xs: 12,
                                        container: true,
                                        direction: "column",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_13___default().general_info_title),
                                                children: translateCommon("footer.general_info")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                item: true,
                                                container: true,
                                                alignItems: "center",
                                                className: "".concat((_styles_module_css__WEBPACK_IMPORTED_MODULE_13___default().general_info_item), " general_info"),
                                                id: "career_link",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_atoms__WEBPACK_IMPORTED_MODULE_1__/* .LinkComp */ .vk, {
                                                    href: "".concat(constants_Paths__WEBPACK_IMPORTED_MODULE_3__/* .PATH_BUYMED_CAREER */ .Nc, "/job-openings/?job__location_spec=cambodia-office-st-528-sangkat-boeung-kak-1-khan-toul-kork-phnom-penh"),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_10__/* .ImageFallbackStatic */ .ez, {
                                                            src: "/static/images/footer/career_inactive.svg",
                                                            layout: "fixed",
                                                            height: "20px",
                                                            width: "20px",
                                                            alt: "linked-career",
                                                            id: "career"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            style: {
                                                                marginLeft: "10px"
                                                            },
                                                            children: translateCommon("footer.career")
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                item: true,
                                                container: true,
                                                alignItems: "center",
                                                className: "".concat((_styles_module_css__WEBPACK_IMPORTED_MODULE_13___default().general_info_item), " general_info"),
                                                id: "aboutUs_link",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_atoms__WEBPACK_IMPORTED_MODULE_1__/* .LinkComp */ .vk, {
                                                    href: constants_Paths__WEBPACK_IMPORTED_MODULE_3__/* .ABOUT_US_URL */ .cK,
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_10__/* .ImageFallbackStatic */ .ez, {
                                                            src: "/static/images/footer/aboutUs_inactive.svg",
                                                            layout: "fixed",
                                                            height: "20px",
                                                            width: "20px",
                                                            alt: "linked-connect",
                                                            id: "aboutUs"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            style: {
                                                                marginLeft: "10px"
                                                            },
                                                            children: translateCommon("footer.about_us")
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                item: true,
                                                container: true,
                                                alignItems: "center",
                                                className: "".concat((_styles_module_css__WEBPACK_IMPORTED_MODULE_13___default().general_info_item), " general_info"),
                                                id: "information_link",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_atoms__WEBPACK_IMPORTED_MODULE_1__/* .LinkComp */ .vk, {
                                                    href: constants_Paths__WEBPACK_IMPORTED_MODULE_3__/* .GUIDE_URL */ .$h,
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_10__/* .ImageFallbackStatic */ .ez, {
                                                            src: "/static/images/footer/information_inactive.svg",
                                                            layout: "fixed",
                                                            height: "20px",
                                                            width: "20px",
                                                            alt: "linked-connect",
                                                            id: "information"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            style: {
                                                                marginLeft: "10px"
                                                            },
                                                            children: translateCommon("footer.user_guide")
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                        item: true,
                                        xs: 12,
                                        container: true,
                                        style: {
                                            marginTop: !isMobile ? "0px" : "12px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_13___default().general_info_title),
                                                children: translateCommon("footer.payment_method")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                item: true,
                                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_13___default().paymentIcon),
                                                style: {
                                                    paddingRight: "8px"
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_10__/* .ImageFallbackStatic */ .ez, {
                                                    src: "/icons/payment_method_aba_khqr.svg",
                                                    layout: "fixed",
                                                    height: "24px",
                                                    width: "42px",
                                                    alt: "ABA-KHQR"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                item: true,
                                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_13___default().paymentIcon),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_10__/* .ImageFallbackStatic */ .ez, {
                                                    src: "/icons/payment_method_cod.svg",
                                                    layout: "fixed",
                                                    height: "24px",
                                                    width: "42px",
                                                    alt: "COD"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                item: true,
                                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_13___default().paymentIcon),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_10__/* .ImageFallbackStatic */ .ez, {
                                                    src: "/icons/payment_method_transfer.svg",
                                                    layout: "fixed",
                                                    height: "24px",
                                                    width: "42px",
                                                    alt: "Transfer"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                item: true,
                                container: true,
                                direction: !isMobile ? "row" : "row-reverse",
                                xs: !isMobile ? 5 : 12,
                                justifyContent: !isMobile ? "space-between" : "flex-end",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                        item: true,
                                        xs: !isMobile ? 12 : 4,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_13___default().general_info_title),
                                                children: translateCommon("footer.connect_with_us")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_13___default().connectIconGroup),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_13___default().connectIcon),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                                                            href: constants_Paths__WEBPACK_IMPORTED_MODULE_3__/* .PATH_TS_FACEBOOK */ .ly,
                                                            passHref: true,
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: constants_Paths__WEBPACK_IMPORTED_MODULE_3__/* .PATH_TS_FACEBOOK */ .ly,
                                                                target: "_blank",
                                                                rel: "noreferrer",
                                                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_13___default().footer_icon),
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_10__/* .ImageFallbackStatic */ .ez, {
                                                                    src: "/static/images/footer/fb.svg",
                                                                    height: "36",
                                                                    width: "36",
                                                                    alt: "facebook-connect"
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_13___default().connectIcon),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                                                            href: constants_Paths__WEBPACK_IMPORTED_MODULE_3__/* .PATH_TS_LINKED */ .Wj,
                                                            passHref: true,
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: constants_Paths__WEBPACK_IMPORTED_MODULE_3__/* .PATH_TS_LINKED */ .Wj,
                                                                target: "_blank",
                                                                rel: "noreferrer",
                                                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_13___default().footer_icon),
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_10__/* .ImageFallbackStatic */ .ez, {
                                                                    src: "/static/images/footer/linkedin.svg",
                                                                    height: "36",
                                                                    width: "36",
                                                                    alt: "linked-connect"
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_13___default().connectIcon),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                                                            href: constants_Paths__WEBPACK_IMPORTED_MODULE_3__/* .PATH_TS_TELE_CAM */ .bx,
                                                            passHref: true,
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: constants_Paths__WEBPACK_IMPORTED_MODULE_3__/* .PATH_TS_TELE_CAM */ .bx,
                                                                target: "_blank",
                                                                rel: "noreferrer",
                                                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_13___default().footer_icon),
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_10__/* .ImageFallbackStatic */ .ez, {
                                                                    src: "/static/images/footer/tele.svg",
                                                                    height: "36",
                                                                    width: "36",
                                                                    alt: "tiktok-connect"
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                        item: true,
                                        xs: !isMobile ? 12 : 7,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_13___default().general_info_title),
                                                children: translateCommon("footer.download_app")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    paddingTop: 12
                                                },
                                                children: [
                                                    !isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        style: {
                                                            marginRight: 12
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                            href: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .LINK_DOWNLOAD_AUTO_DETECT */ .iXA,
                                                            target: "_blank",
                                                            rel: "noreferrer",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                                                                src: "/static/images/footer/qr.png",
                                                                width: "88",
                                                                height: "88"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                    href: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .LINK_APPLESTORE */ .xAG,
                                                                    target: "_blank",
                                                                    rel: "noreferrer",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                                                                        src: "/static/images/footer/appstore-3.svg",
                                                                        width: "107",
                                                                        height: "37"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                style: {
                                                                    marginTop: 10
                                                                },
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                    href: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .LINK_GOOGLEPLAY */ .R7l,
                                                                    target: "_blank",
                                                                    rel: "noreferrer",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                                                                        src: "/static/images/footer/ggplay.svg",
                                                                        width: "107",
                                                                        height: "35"
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FooterCam);


/***/ }),

/***/ 76412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fi": function() { return /* binding */ TagCode; },
/* harmony export */   "_A": function() { return /* binding */ MENUS_UTIL; },
/* harmony export */   "dU": function() { return /* binding */ MENUS_USER_INFO; },
/* harmony export */   "ek": function() { return /* binding */ ENUM_PRODUCT_TYPE; },
/* harmony export */   "jj": function() { return /* binding */ ENUM_SELLER_TYPE; },
/* harmony export */   "oG": function() { return /* binding */ tagList; },
/* harmony export */   "ob": function() { return /* binding */ MENUS_SUPPORT; },
/* harmony export */   "wf": function() { return /* binding */ ACCOUNTS_TRIAL; }
/* harmony export */ });
/* unused harmony exports HOME_MENUS, BRAND_NAME_SHORT, BRAND_NAME, BRAND_NAME_LONG, ADDRESS_BUSSINESS, PHONE_NUMBER_STR, PHONE_NUMBER, LINK_DIRECT_TO_MESSENGER, LINK_DIRECT_TO_TELE */
/* harmony import */ var constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93893);
/* harmony import */ var constants_Paths__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(199);


var HOME_MENUS = [
    {
        name: "menu.products",
        url: constants_Paths__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCTS_URL */ .NL,
        icon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_ICON */ .dU,
        id: 1
    },
    {
        name: "menu.ingredients",
        url: constants_Paths__WEBPACK_IMPORTED_MODULE_0__/* .INGREDIENT */ .gL,
        icon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .INGREDIENT_ICON */ .HO,
        id: 2
    },
    {
        name: "menu.promotion",
        url: constants_Paths__WEBPACK_IMPORTED_MODULE_0__/* .PROMO_CODES */ .Q2,
        icon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .COUPON_ICON */ .PL,
        id: 3
    }, 
];
var BRAND_NAME_SHORT = "BuyMed";
var BRAND_NAME = "BuyMed";
var BRAND_NAME_LONG = "BuyMed";
var ADDRESS_BUSSINESS = "Warehouse N.6, Street 528, Phum2, Sangkat Boeung kak1 , Khan Toul Kork, Phnom Penh, Cambodia.";
var PHONE_NUMBER_STR = "098888437";
var PHONE_NUMBER = "+85598888437";
var LINK_DIRECT_TO_MESSENGER = "https://m.me/thuocsivn";
var LINK_DIRECT_TO_TELE = "https://telegram.me/+85598888437";
var MENUS_USER_INFO = [
    {
        name: "personal_info",
        href: "/my-account",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .MOBILE_USER_ICON */ .qe
    },
    // {
    //   name: 'Thông tin cấp bậc',
    //   href: '',
    //   srcIcon: LEVEL_ICON,
    // },
    {
        name: "business_info",
        href: "/user/business-information",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .BUSINESS_ICON */ .zG
    }, 
];
var MENUS_UTIL = [
    {
        name: "my_orders",
        href: "/my-order",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_ICON */ .Ln
    },
    {
        name: "bill_of_lading_lookup",
        href: "/tracking-order",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .TRUCK_ICON */ .rx
    },
    // {
    //   name: 'Thông tin xuất hóa đơn',
    //   href: '/productviewed',
    //   srcIcon: DOCUMENT_ICON2,
    // },
    {
        name: "order_statistics",
        href: "/user/dashboard",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .INSIGHT_ICON */ .hr
    },
    {
        name: "viewed_products",
        href: "/productviewed",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .M_EYE_ICON */ .C6
    },
    {
        name: "refer_friends",
        href: "/users/referrals",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .INFO_ICON */ .lS
    },
    {
        name: "my_discount",
        href: constants_Paths__WEBPACK_IMPORTED_MODULE_0__/* .USER_PROMO_CODES_URL */ .Py,
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .MOBILE_VOUCHER_ICON */ .He
    },
    {
        name: "interested_products",
        href: "/user/wishlist",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .HEART_ICON */ .Un
    },
    {
        name: "look_up_product",
        href: "/qr",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .RESEARCH_INFO_ICON */ .x7
    },
    {
        name: "my_feedback",
        href: "/users/my-ticket",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .CHAT_ICON */ .cK
    },
    {
        name: "reward_points",
        href: "/users/loyalty_points",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .POINT_ACCUMULATING_ICON */ .bv
    },
    {
        name: "reward_events",
        href: "/users/rewards",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .HAND_SHAKE_ICON */ .wp
    }, 
];
var MENUS_SUPPORT = [
    {
        name: "common_questions",
        href: "https://thuocsihotro.helpwise.help/",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .QUESTION_ICON */ .RD
    },
    {
        name: "hotline",
        href: "tel:+842873008840",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .PHONE_ICON */ .EU
    },
    {
        name: "hotline_tele",
        href: "tel:+098888437",
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .PHONE_ICON */ .EU
    },
    {
        name: "chat_contact",
        href: LINK_DIRECT_TO_MESSENGER,
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .CONTACT_ICON */ .KX
    },
    {
        name: "chat_contact_tele",
        href: LINK_DIRECT_TO_TELE,
        srcIcon: constants_Images_mobile__WEBPACK_IMPORTED_MODULE_1__/* .CONTACT_ICON */ .KX
    }, 
];
var ENUM_PRODUCT_TYPE = {
    KHUYENMAI: "khuyenmai",
    NEW: "new",
    FAV: "fav"
};
var ENUM_SELLER_TYPE = {
    ALL: "all",
    FLAGSHIP: "flagship"
};
var ACCOUNTS_TRIAL = {
    prd: [
        16236,
        59954,
        31217,
        46433,
        24079,
        40543,
        31680,
        33223,
        606,
        63761,
        82295,
        29412,
        3556,
        74843,
        74326,
        14183,
        42320,
        68705,
        51644,
        13344,
        726,
        91787,
        56644,
        52904,
        43409,
        40132,
        22272,
        81345,
        76029,
        46913,
        54056,
        8244,
        3013,
        37592,
        221073,
        79549,
        227444,
        91661,
        62743,
        218228,
        89357,
        244185,
        48845,
        253562,
        73230,
        74027,
        45079,
        4968,
        89768,
        92729,
        234491,
        249365,
        89377,
        55990,
        38097,
        94401,
        225343,
        91230,
        94843,
        82919,
        81372,
        253699,
        226652,
        237691,
        248883,
        227714,
        92730,
        11856,
        244703,
        205792,
        253556,
        60803,
        218616,
        82835,
        226001,
        79342,
        36289,
        68951,
        218511,
        73802,
        11244,
        28393,
        68476,
        270946,
        245254,
        34936,
        31539,
        88356,
        233664,
        226273,
        91487,
        222566,
        82221,
        238730,
        225688,
        235299,
        53784,
        222654,
        46359,
        267038,
        69353,
        80958,
        227446,
        251412,
        230234,
        255311,
        29976,
        47701,
        230086,
        52621,
        31835,
        83101,
        56124,
        223662,
        90539,
        71992,
        248895,
        245519,
        61808,
        253238,
        48727,
        64801,
        91247,
        242995,
        254007,
        224139,
        205065,
        90169,
        206435,
        61136,
        39267,
        91029,
        43805,
        242804,
        64655,
        248894,
        73573,
        62199,
        92335,
        74466,
        37820,
        244195,
        23096,
        25678,
        217377,
        236150,
        77357,
        32791,
        266958,
        243821,
        16236,
        59954,
        31217,
        46433,
        24079,
        40543,
        31680,
        33223,
        606,
        63761,
        82295,
        29412,
        3556,
        74843,
        74326,
        14183,
        42320,
        68705,
        51644,
        13344,
        726,
        91787,
        56644,
        52904,
        43409,
        40132,
        22272,
        81345,
        76029,
        46913,
        54056,
        8244,
        3013,
        37592,
        221073,
        79549,
        227444,
        91661,
        62743,
        218228,
        89357,
        244185,
        48845,
        253562,
        73230,
        74027,
        45079,
        4968,
        89768,
        92729,
        234491,
        249365,
        89377,
        55990,
        38097,
        94401,
        225343,
        91230,
        94843,
        82919,
        81372,
        253699,
        226652,
        237691,
        248883,
        227714,
        92730,
        11856,
        244703,
        205792,
        253556,
        60803,
        218616,
        82835,
        226001,
        79342,
        36289,
        68951,
        218511,
        73802,
        11244,
        28393,
        68476,
        270946,
        245254,
        34936,
        31539,
        88356,
        233664,
        226273,
        91487,
        222566,
        82221,
        238730,
        225688,
        235299,
        53784,
        222654,
        46359,
        267038,
        69353,
        80958,
        227446,
        251412,
        230234,
        255311,
        29976,
        47701,
        230086,
        52621,
        31835,
        83101,
        56124,
        223662,
        90539,
        71992,
        248895,
        245519,
        61808,
        253238,
        48727,
        64801,
        91247,
        242995,
        254007,
        224139,
        205065,
        90169,
        206435,
        61136,
        39267,
        91029,
        43805,
        242804,
        64655,
        248894,
        73573,
        62199,
        92335,
        74466,
        37820,
        244195,
        23096,
        25678,
        217377,
        236150,
        77357,
        32791,
        266958,
        243821,
        247359,
        247884,
        254737,
        260042,
        247657, 
    ],
    stg: [
        2511,
        2871,
        2730
    ]
};
var TagCode = {
    SP: "@SP_",
    DH: "@DH_",
    HOTRO: "@HOTRO_"
};
var tagList = [
    {
        code: TagCode.SP,
        image: "/icons/mobile/chat/SP.svg",
        title: "Tag sản phẩm",
        titleCode: "product_tag",
        guide: "".concat(TagCode.SP)
    },
    {
        code: TagCode.DH,
        image: "/icons/mobile/chat/DH.svg",
        title: "Tag đơn h\xe0ng",
        titleCode: "order_tag",
        guide: "".concat(TagCode.DH)
    },
    {
        code: TagCode.HOTRO,
        image: "/icons/mobile/chat/HOTRO.svg",
        title: "Tag phiếu hỗ trợ",
        titleCode: "support_ticket_tag",
        guide: "".concat(TagCode.HOTRO)
    }, 
];
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({});


/***/ }),

/***/ 45045:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"btngroup":"styles_btngroup__pZa7D","custombtn":"styles_custombtn__J_RrK","info_content":"styles_info_content__QJSeh","footer":"styles_footer__5o0pY","mobile_footer":"styles_mobile_footer__h_TC0","connectIconGroup":"styles_connectIconGroup__9R62A","connectIcon":"styles_connectIcon__u3gPf","general_info_title":"styles_general_info_title__4hflx","general_info_item":"styles_general_info_item__3kzzr","license":"styles_license__cOLJz","policyName":"styles_policyName__QCX5u","footer_icon":"styles_footer_icon__yOWcg","paymentIcon":"styles_paymentIcon__2Es6k"};

/***/ }),

/***/ 15615:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__W8A0f","bg_mobile":"styles_bg_mobile__0fHqn","new_bg_mobile":"styles_new_bg_mobile__pah2X","btngroup":"styles_btngroup__x0ZkC","custombtn":"styles_custombtn__BJ8nr","text_modal":"styles_text_modal__U3_8c","appBar":"styles_appBar__Ltgsd"};

/***/ })

}]);